import { render, staticRenderFns } from "./froala-editor.vue?vue&type=template&id=ae51db86"
import script from "./froala-editor.vue?vue&type=script&lang=js"
export * from "./froala-editor.vue?vue&type=script&lang=js"
import style0 from "./froala-editor.vue?vue&type=style&index=0&id=ae51db86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports